export const selectUser = (state: any) => {
    return state.user;
};